import { GetOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

export default class UserApi extends BaseApi {
  static entityName = 'users';

  fetchSelf(params = {}, withPreloader = false) {
    const operation = new GetOperation('/api/self', params);
    return this.execute(operation, withPreloader);
  }
}
